import CardDsfrContext from "components/CardDsfrContext";
import LanguageContext from "components/LanguageContext";
import BadgeToDisplay from "components/templatesComponents/BadgeToDisplay";
import Link from "components/templatesComponents/Link";
import { useFindPages } from "hooks/page.hook";
import { useGetAllSites } from "hooks/site.hook";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";
import { numericFormatDate } from "utils/commonUtils";
import t from "utils/locales/translation.json";

const CardHighlighted = ({ page: pageVersion }) => {
  const { image, title, fullPath, page, pageId } = pageVersion || {};
  const { lang, originalPageId, siteId, firstPublishedDate } = page || {};
  const { props } = image || {};
  const { file, alt = "" } = props || {};
  const { url } = file || {};

  const { language } = useContext(LanguageContext);

  const { isHorizontal } = useContext(CardDsfrContext);

  const { data: allSites = [] } = useGetAllSites();

  const { data: frenchPnuPages = [] } = useFindPages({
    siteId,
    pageId: lang === "FR" ? pageId : originalPageId,
    filters: [`page.lang||eq||FR`],
  });

  const findSiteById = useMemo(() => allSites.find((site) => site.id === siteId), [allSites, siteId]);

  const { host } = findSiteById || {};

  const { firstPublishedDate: frenchPublishDate } = frenchPnuPages[0] || {};

  const date = lang === "FR" ? firstPublishedDate : frenchPublishDate || firstPublishedDate;

  if (pageVersion === undefined) {
    return null;
  }

  const isBoFullPath =
    fullPath && fullPath.includes("site=") && fullPath.includes("page=") && fullPath.includes("version=");

  return (
    <div className={`fr-card fr-enlarge-link ${isHorizontal && "fr-card--horizontal-tier"}`}>
      <div className="fr-card__body">
        <div className="fr-card__content">
          <h4 className="fr-card__title">
            <Link basic url={isBoFullPath ? fullPath : `${host}${fullPath}`} sx={{ wordBreak: "break-word" }}>
              {title}
            </Link>
          </h4>
          {firstPublishedDate && (
            <div className="fr-card__start">
              <p className="fr-card__detail fr-icon-calendar-event-fill">
                {t[language].common.news.published_label} {numericFormatDate({ date, lang })}
              </p>
            </div>
          )}
        </div>
      </div>
      <div className="fr-card__header">
        <div className="fr-card__img">
          <img className="fr-responsive-img" src={url || "/default-image.png"} alt={alt} />
        </div>
        <ul className="fr-badges-group">
          <li>
            <BadgeToDisplay label="highlighted" color="info" />
          </li>
        </ul>
      </div>
    </div>
  );
};

CardHighlighted.propTypes = {
  page: PropTypes.shape().isRequired,
};

export default CardHighlighted;
